


























import { Component, Vue, Prop } from "vue-property-decorator";
import { format, parseISO, addSeconds } from "date-fns";

@Component({})
export default class ShiftCard extends Vue {
	@Prop() private shift: any;
	@Prop() private openShift: Function;
	@Prop() private actionMode: string;

	formatShiftPeriod(shift: any, mobile: boolean): any {
		const durationParts = shift.durationTime.split(":");
		const durationSeconds = parseInt(durationParts[0]) * 3600 + parseInt(durationParts[1]) * 60 + parseInt(durationParts[2]);

		const startDateTime = parseISO(shift.startDateTime);
		const endDateTime = addSeconds(startDateTime, durationSeconds);

		if (mobile) {
			return `${format(startDateTime, "HH:mm")} ${format(endDateTime, "HH:mm")}`;
		} else {
			return `${format(startDateTime, "HH:mm")} - ${format(endDateTime, "HH:mm")}`;
		}

	}
}
